<template>
  <div class="step-navigation">
    <button class="nav-button prev-button" v-if="!isFirstStep && !isLastStep" :disabled="!previousButtonEnabled" :class="{'disabled': !previousButtonEnabled}" @click="handlePreviousButtonPress">
      {{  previousButtonText }}
    </button>
    <button class="nav-button next-button" v-if="!isLastStep" :disabled="!nextButtonEnabled" :class="{'disabled': !nextButtonEnabled}" @click="handleNextButtonPress">
      {{ nextButtonText }}
    </button>
  </div>
</template>


<script>
import useStepNavigation from "@/composables/useStepNavigation";
import {computed, onMounted} from "vue";
import useTexts from "@/composables/useTexts";

export default {
  setup() {

    const {
      curStep,
      nrOfSteps,
      previousButtonEnabled,
      nextButtonEnabled,
      previousButtonText,
      nextButtonText,
      previousButtonPressed,
      nextButtonPressed
    } = useStepNavigation();

    const isFirstStep = computed(() => curStep.value === 1);
    const isLastStep = computed(() => curStep.value === nrOfSteps);

    const handlePreviousButtonPress = () => {
      previousButtonPressed.value = true;
    };

    const handleNextButtonPress = () => {
      nextButtonPressed.value = true;
    };

    const { getTextsForComponent } = useTexts();
    const t = getTextsForComponent('StepNavigation');

    onMounted(() => {
      previousButtonText.value = t.value.previous_step;
    });

    return {
      handlePreviousButtonPress,
      handleNextButtonPress,
      previousButtonEnabled,
      nextButtonEnabled,
      previousButtonText,
      nextButtonText,
      curStep,
      nrOfSteps,
      isFirstStep,
      isLastStep,
      t
    };
  }
}
</script>

<style scoped>
.step-navigation {
  display: flex;
  justify-content: flex-end;
  margin: 10px 0;
}

.nav-button {
  color: white;
  background-color: #999;
  border: none;
  padding: 10px;
  min-width: 100px;
  text-align: center;
  font-size: 1.2em;
  cursor: pointer;
}

.nav-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.prev-button {
  margin-right: auto;
}
</style>
